<template>
  <component :is="customTag" ref="element"/>
</template>

<script setup>
import {
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from 'vue';
import MediumEditor from 'medium-editor';

defineOptions({ name: 'MediumEditor' });

const props = defineProps({
  text: {
    type: String,
    default: null,
  },
  customTag: {
    type: String,
    default: 'div',
  },
  options: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['edit', 'editorCreated']);

const element = ref(null);
let api = null;

const onEditableInput = (event) => {
  emit('edit', { event, api });
};

const createAndSubscribe = () => {
  element.value.innerHTML = props.text;
  api = new MediumEditor(element.value, props.options);
  api.subscribe('editableInput', onEditableInput);
  emit('editorCreated', api);
};

const tearDown = () => {
  api.unsubscribe('editableInput', onEditableInput);
  api.destroy();
};

onMounted(createAndSubscribe);
onBeforeUnmount(tearDown);

watch(() => props.text, (newText) => {
  if (newText !== element.value.innerHTML) {
    api.setContent(newText, 0);
    element.value.innerHTML = newText;
  }
});

watch(() => props.options, () => {
  tearDown();
  createAndSubscribe();
});
</script>
